export default {
  SAVE_LIST_BOOKING_CAR: 'SAVE_LIST_BOOKING_CAR',
  CLEAR_LIST_BOOKING_CAR: 'CLEAR_LIST_BOOKING_CAR',
  SAVE_ALL_LIST_EVENT: 'SAVE_ALL_LIST_EVENT',
  SAVE_ALL_LIST_EVENT_SIDE_BAR: 'SAVE_ALL_LIST_EVENT_SIDE_BAR',
  CLEAR_ALL_LIST_EVENT: 'CLEAR_ALL_LIST_EVENT',
  CLEAR_ALL_LIST_EVENT_SIDE_BAR: 'CLEAR_ALL_LIST_EVENT_SIDE_BAR',
}
